// Mythicals — ultra-rare, single-slot, consumable items that drop from
// chests (~8% of correct-team loot). One-shot cinematics. Distinct from
// Legendary boss drops (those are permanent stat buffs).
//
// deathnote    — instakill one enemy at any range within MAX_RANGE.
//                Gated by MYTHIC_DEATHNOTE_LOCKOUT_SEC from match start.
// going_viral  — Mario-star buff for MYTHIC_VIRAL_DUR_MS. Speed ×2,
//                damage ×1.6, music tempo ×1.4 (local-only), rainbow
//                outline visible to everyone.

import type { MythicalId } from '../net/protocol';

export type MythicalDef = {
  id: MythicalId;
  name: string;
  icon: string;      // single emoji for HUD pill fallback
  color: string;     // accent color for pill / pickup orb
  blurb: string;     // tooltip/HUD subtitle
  kind: 'targeted' | 'self'; // targeted = opens picker; self = instant use
};

export const MYTHICALS: Record<MythicalId, MythicalDef> = {
  deathnote: {
    id: 'deathnote',
    name: 'DEATH NOTE',
    icon: '📓',
    color: '#0f172a',
    blurb: 'Write a name. End them.',
    kind: 'targeted',
  },
  going_viral: {
    id: 'going_viral',
    name: 'GOING VIRAL',
    icon: '🌟',
    color: '#fde047',
    blurb: '6s of pure hype — ×2 speed, ×1.6 damage',
    kind: 'self',
  },
};

export const MYTHICAL_IDS: MythicalId[] = ['deathnote', 'going_viral'];

// Drop roll: when a chest spawns a same-team loot item (xp/hp), this
// returns a MythicalId to replace it with, or null to keep the stock
// drop. 8% rate = ~1 mythic per 12 pickups = ~1 per match on average.
export function rollMythicForLoot(): MythicalId | null {
  if (Math.random() > 0.08) return null;
  return Math.random() < 0.5 ? 'deathnote' : 'going_viral';
}

export function mythicalName(id: MythicalId): string {
  return MYTHICALS[id].name;
}
